import React, { FunctionComponent as FC, useRef, useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // To call Action Creators
import { State } from '../../../../../state';
import { bindActionCreators } from "redux";
import { actionCreators } from '../../../../../state';
import './index.scss';

import { MainViewTypes } from '../../../../../types/data';
import { impactEntityList, cpcCode2Name, CitationFlowType, ImpactType } from '../../../../../types/data.global';
import { drawBubbleTreemap } from './drawBubbleTreemap';
// import { glyphStyle, svgSize } from '../../../../../types/style.global';
// temp. TODO: move `glyphStyle` to `style.global.ts`
// import { glyphStyle } from '../../GrantTypeNode';

// // opt 6 - case 2 - vis (第一段，patent, 只选patent-direct/indirect impact的时候)
// [abandon] method 1: import from `bubbleTreemapConfig.ts`
// import { bubbleTreemapStyle } from '../bubbleTreemapConfig';
// method 2: import from uiReducer > svgSize, glyphStyle, see code below in the component
// import { bubbleTreemapStyle } from '../bubbleTreemapConfig';

import _ from 'lodash';
import * as d3 from  "d3";



function useWhyChanged(label: string, deps: Record<string, unknown>) {
  const prevRef = React.useRef<Record<string, unknown> | null>(null);
  useEffect(() => {
    if (prevRef.current) {
      const prev = prevRef.current;
      const changed: string[] = [];
      for (const k of Object.keys(deps)) {
        if (prev[k] !== deps[k]) changed.push(k);
      }
      if (changed.length) {
        console.log(`[${label}] changed:`, changed.join(", "));
        // 也可以打印具体值（注意不要爆巨量对象）
        // changed.forEach(k => console.log(` - ${k}:`, { prev: prev[k], next: deps[k] }));
      } else {
        console.log(`[${label}] no change`);
      }
    }
    prevRef.current = deps;
  });
}



type BubbleNodeDatum = {
  name: string;
  type: string;
  x: number;
  y: number;
  radius: number;
  value?: number;
  children?: BubbleNodeDatum[];
};

interface HighlightedGrantGroupNode {
  grantFieldID: string,
  grantFieldName: string,
}

interface InitializeBubbleTreemapProps {
  // main data
  entityFieldGraphData: any;
  predictionDataDict: MainViewTypes.PredictionResultDict;

  // ui parameters
  selectedImpactTypeList: string[];
  impactType: string;
  impactTypeRefined: string;
}

const InitializeBubbleTreemap: FC<InitializeBubbleTreemapProps> = (props) => {

  const { entityFieldGraphData, predictionDataDict,selectedImpactTypeList, impactType, impactTypeRefined } = props

  // opt 1: useMemo to make action references stable
  const dispatch = useDispatch()
  // ⭐ 让 action 引用稳定
  const actions = useMemo(
    () => bindActionCreators(actionCreators, dispatch),
    [dispatch]
  )
  const {
    // layout data
    // updateBubbleTreemapCircumscribedRadiiDict,
    updateLeafNodeInitialPositionList,
    updateIsInitializeBubbleTreemapFinished,
    updateIsEntityFieldGraphFinished,
    updateLeafNodeSizeScale,
    updateBubbleTreemapEntityGroupList,
    updateBubbleTreemapGeometryGroup,

    // ui

    // wordle
    isShowWordle,
    updateWordlePosition,
    updateWordleEntity,

    // interaction
    updateSelectedImpactEntityField,
    isShowPredictionFlow,
    isShowHistoricalFlow,
    updatePredictionSearchResult,
    updatePredictionGrantIDList4PIView,
    onClickGrantFieldNode,
    onClickImpactFieldNode,

    // layout
    getMainViewlayoutOptimizationParams,
    isOptimizingMainViewLayoutFinished,
  } = actions

  // // opt 2: use bindActionCreators to make action references stable
  // const dispatch = useDispatch()
  // const {
  //   // layout data
  //   // updateBubbleTreemapCircumscribedRadiiDict,
  //   updateLeafNodeInitialPositionList,
  //   updateIsInitializeBubbleTreemapFinished,
  //   updateIsEntityFieldGraphFinished,
  //   updateLeafNodeSizeScale,
  //   updateBubbleTreemapEntityGroupList,
  //   updateBubbleTreemapGeometryGroup,

  //   // ui

  //   // wordle
  //   isShowWordle,
  //   updateWordlePosition,
  //   updateWordleEntity,

  //   // interaction
  //   updateSelectedImpactEntityField,
  //   isShowPredictionFlow,
  //   isShowHistoricalFlow,
  //   updatePredictionSearchResult,
  //   updatePredictionGrantIDList4PIView,
  //   onClickGrantFieldNode,
  //   onClickImpactFieldNode,

  //   // layout
  //   getMainViewlayoutOptimizationParams,
  //   isOptimizingMainViewLayoutFinished,
  // } = bindActionCreators(actionCreators, dispatch)


  // ui reducer
  const sharedBubbleTreemapStyle: MainViewTypes.BubbleTreemapStyle = useSelector((state: State) => state.uiReducer?.sharedBubbleTreemapStyle) as MainViewTypes.BubbleTreemapStyle
  const svgSize: MainViewTypes.SVGSize = useSelector((state: State) => state.uiReducer?.svgSize) as MainViewTypes.SVGSize
  const glyphStyle: MainViewTypes.GlyphStyle = useSelector((state: State) => state.uiReducer?.glyphStyle) as MainViewTypes.GlyphStyle
  const isEntityTypeGraphFinished = useSelector((state: State) => state.dataReducer?.isEntityTypeGraphFinished) as boolean;

  // data reducer
  const entityTypeLayoutData = useSelector((state: State) => state.dataReducer?.entityTypeLayoutData) as any


  // // debug
  // console.log('================ InitializeBubbleTreemap: started! =================')
  // console.log('==> InitializeBubbleTreemap: entityTypeLayoutData: ', entityTypeLayoutData)


  // ⭐ 一次性护栏：本轮只许请求一次
  const layoutRequestedRef = useRef(false);
  // ⭐ 视为“新一轮 MainView”的信号 -> 重置护栏
  // 你可以按你的刷新判定来添加依赖，最常见的是：
  // - entityTypeLayoutData 改变（上游骨架布局变了）
  // - selectedImpactTypeList 改变（筛选项变化）
  // - impactType / impactTypeRefined 改变
  // 解释：每轮主视图刷新开始（这些关键依赖变了）就把“已请求”标记清零；随后只要发过一次优化请求，就把它设回 true，这一轮不再重复发。
  useEffect(() => {
    // 每当 mainview 的输入发生变化，重置“只发一次”的护栏
    layoutRequestedRef.current = false;
  }, [entityTypeLayoutData, selectedImpactTypeList, impactType, impactTypeRefined]);



  // pre-process: ui parameters
  const bubbleTreemapStyle = sharedBubbleTreemapStyle;


  // --- 1-2 calc bubble treemap (entity-field level): for all impact types ---
  /*
    input: `entityFieldGraphData`
  */

  // 1. fetch data from redux
  // ui reducer
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string
  const isShowLeafNode: boolean = useSelector((state: State) => state.uiReducer?.isShowLeafNode) as boolean

  // console.log('==> InitializeBubbleTreemap > citationFlowType: ', citationFlowType)

  // 2. pre-process data for circle packing
  /* filter `entityFieldGraphData`, based on selected `impactType` and `selectedImpactTypeList` */
  // 2-1 get `mainviewData`

  // opt 1: useMemo to make action references stable
  const { mainviewData, updatedEntityFieldData } = useMemo(() => {
    let mv: any = {};
    if (!_.isEmpty(entityFieldGraphData)) {
      if (impactType === ImpactType.INDIRECT_IMPACT_FOLDED) {
        const node_IndirectImpact_folded = _.omit(
          entityFieldGraphData[impactTypeRefined].node,
          'paper'
        );
        mv = {
          node: node_IndirectImpact_folded,
          link: entityFieldGraphData[impactTypeRefined].link.folded,
          grant_field_level_data: entityFieldGraphData[impactTypeRefined].grant_field_level_data,
        };
      } else if (impactType === ImpactType.DIRECT_IMPACT) {
        mv = entityFieldGraphData[impactType];
      } else if (impactType === ImpactType.INDIRECT_IMPACT_UNFOLDED) {
        mv = {
          node: entityFieldGraphData[impactTypeRefined].node,
          link: entityFieldGraphData[impactTypeRefined].link.unfolded,
          grant_field_level_data: entityFieldGraphData[impactTypeRefined].grant_field_level_data,
        };
      }
    }

    const input: any[] = [];
    if (!_.isEmpty(mv)) {
      // 如果 node 是对象而不是数组，保证稳定顺序（可选，但推荐）
      const entries = Array.isArray(mv.node)
        ? mv.node
        : Object.values(mv.node);

      entries.forEach((entityData: any) => {
        const hierarchicalData = _.cloneDeep(entityData['hierarchical_entity_field_data']);
        if (hierarchicalData) input.push(hierarchicalData);
      });
    }

    return { mainviewData: mv, updatedEntityFieldData: input };
  }, [entityFieldGraphData, impactType, impactTypeRefined]);


  // // opt 2: original functions --- start ---
  // let mainviewData: any = {}
  // let entityFieldGraph_InputData: any[] = []
  // if (!_.isEmpty(entityFieldGraphData)) {
  //   // 1. only for impactType === 'indirect_impact_folded': create a new object without the 'paper' key
  //   if (impactType === ImpactType.INDIRECT_IMPACT_FOLDED) {
  //     let node_IndirectImpact_folded = _.omit(entityFieldGraphData[impactTypeRefined].node, 'paper')
  //     mainviewData = {
  //       'node': node_IndirectImpact_folded,
  //       'link': entityFieldGraphData[impactTypeRefined].link.folded,
  //       'grant_field_level_data': entityFieldGraphData[impactTypeRefined].grant_field_level_data
  //     }
  //   } else if (impactType === ImpactType.DIRECT_IMPACT) {
  //     mainviewData = entityFieldGraphData[impactType]
  //   } else if (impactType === ImpactType.INDIRECT_IMPACT_UNFOLDED) {
  //     mainviewData = {
  //       'node': entityFieldGraphData[impactTypeRefined].node,
  //       'link': entityFieldGraphData[impactTypeRefined].link.unfolded,
  //       'grant_field_level_data': entityFieldGraphData[impactTypeRefined].grant_field_level_data, // temp: currently return folded link, TODO: add unfolded link
  //     }
  //   }
  //   // console.log('mainviewData: ', mainviewData)

  //   // 2-2 get `entityFieldGraph_InputData`
  //   _.forEach(mainviewData.node, (entityData: any, entity: string) => {
  //     const hierarchicalData = _.cloneDeep(entityData['hierarchical_entity_field_data'])
  //     // Check if hierarchicalData is not null before trying to set properties
  //     if (hierarchicalData) {
  //       // update radius
  //       // temp: hard code
  //       // TODO: 现在radius of entity_type node是fixed constant (R=100)。需要根据画布大小等动态更新
  //       // const R = 200
  //       // hierarchicalData['radius'] = R
  //       entityFieldGraph_InputData.push(hierarchicalData)
  //     }
  //   })
  // }
  // // temp: just for easy reading for circle packing code.
  // // todo: replace all 'updatedEntityFieldData' with 'entityFieldGraph_InputData'
  // const updatedEntityFieldData = entityFieldGraph_InputData
  // // opt 2: original functions --- end ---
  // console.log('updatedEntityFieldData: ', updatedEntityFieldData)



  // 2. circle packing: entity-field level
  // const nodes = _.cloneDeep(entityFieldGraph_NodeLinkData.nodes)
  const predictionData = predictionDataDict.grant_id_list_subinstitution  // to show prediction result
  const predictionDataGlobal = predictionDataDict.grant_id_list_all_institute
  const [packedImpactEntityAll, setPackedImpactEntityAll] = useState<any>()
  // const [packedEntityTypes, setPackedEntityTypes] = useState<any[]>([])

  // 2-1 calc circumscribed circle radius (每一类impact node的外切圆)
  const [circumscribedRadii, setCircumscribedRadii] = useState<{[key: string]: number}>({})
  const groupRefs = useRef<{[key: string]: SVGGElement | null}>({})
  function shallowEqualNumberMap(a: Record<string, number>, b: Record<string, number>) {
    const ak = Object.keys(a), bk = Object.keys(b);
    if (ak.length !== bk.length) return false;
    for (const k of ak) if (a[k] !== b[k]) return false;
    return true;
  }
  // Effect to calculate circumscribed radii after render
  useEffect(() => {
    // method 1: 只渲染一次，计算一次
    const newRadii: {[key: string]: number} = {};
    Object.entries(groupRefs.current).forEach(([impactType, ref]) => {
      if (ref) {
        const bbox = ref.getBBox();
        const radius = Math.max(bbox.width, bbox.height) / 2;
        newRadii[impactType] = radius;
      }
    });

    // opt 1: compare the value then decide whether to update
    // 只有半径真的变了才触发后续依赖链，能明显减少“无意义的再次渲染”。
    setCircumscribedRadii(prev =>
      shallowEqualNumberMap(prev, newRadii) ? prev : newRadii
    );

    // opt 2: directly update variable
    // setCircumscribedRadii(newRadii);



    // // update dataReducer
    // updateBubbleTreemapCircumscribedRadiiDict(newRadii)

    // method 2: 渲染多次，每次渲染都计算一次
    // Object.entries(groupRefs.current).forEach(([impactType, ref]) => {
    //   if (ref) {
    //     const bbox = ref.getBBox();
    //     const radius = Math.max(bbox.width, bbox.height) / 2;
    //     // const radius = Math.sqrt(Math.pow(bbox.width, 2) + Math.pow(bbox.height, 2)) / 2;
    //     setCircumscribedRadii(prev => ({
    //       ...prev,
    //       [impactType]: radius
    //     }));
    //   }
    // });
  }, [packedImpactEntityAll]); // Recalculate when packed data changes
  // console.log('circumscribedRadii: ', circumscribedRadii)





  // Step 2: two parallel steps:
  // --- 2-1 bubble treemap post-process: (1) scale size (by a parameter `alpha`); (2) transform position (x, y), along the edge of backbone graph in Step 1-1 ---
  // input
  const svgR: number = Math.min(svgSize.width, svgSize.height) / 2
  // console.log('circumscribedRadii: ', circumscribedRadii) // impact type circle
  // console.log('GrantGlyphGroupOuterR: ', glyphStyle.grantGlyphGroupR)
  // console.log('svgR: ', svgR)

  // Step 3: 串行：前两步完成后再进行布局优化
  // const optimizedLayoutData = useLayoutOptimization(entityTypeLayoutData, bubbleTreeMapData);
  useEffect(() => {
    if (_.isEmpty(circumscribedRadii)) return;
    if (!entityTypeLayoutData) return;
    if (!isEntityTypeGraphFinished) return;

    // ⭐ 护栏：本轮只发一次
    if (layoutRequestedRef.current) return;

    if (!_.isEmpty(circumscribedRadii) && entityTypeLayoutData && isEntityTypeGraphFinished) {
      // // debug
      // console.log('circumscribedRadii: ', circumscribedRadii)
      // console.log('entityTypeLayoutData: ', entityTypeLayoutData)

      // 1. prepare parameters
      const parameters = {
        svgMaxR: svgR,
        grantGlyphGroupR: glyphStyle.grantGlyphGroupR,
        circumscribedRadiiDict: circumscribedRadii,
        rayUnitVectorDict: entityTypeLayoutData.nodeDirections_ray_unit_vectors,
        relativeLengthDict: entityTypeLayoutData.nodeDistances,
      }

      // call backend function
      const layoutOptimization = async () => {
        try {
          // console.log('getMainViewlayoutOptimizationParams(), parameters: ', parameters)
          const result = await getMainViewlayoutOptimizationParams(parameters)
        } catch (error) {
          console.error(error);
          // setIsResearcherDetailsViewLoading(false)
        } finally {
          isOptimizingMainViewLayoutFinished(true)
          //console.log('Researcher View update finished');
          // setIsResearcherDetailsViewLoading(false)
        }
      }
      layoutOptimization();
    }
  }, [
    // 只保留“数据依赖”，不要把 action 函数放进来
    circumscribedRadii,
    entityTypeLayoutData,
    svgR,
    isEntityTypeGraphFinished,
    glyphStyle.grantGlyphGroupR,
    // getMainViewlayoutOptimizationParams, isOptimizingMainViewLayoutFinished
  ])










  // 2-2 pre-process data for circle packing
  const leafNodeSizeScaleType = bubbleTreemapStyle.leafNodeSizeScaleType
  useEffect(() => {
    // Clear previous packed data to ensure clean state
    setPackedImpactEntityAll(null)

    // console.log('\n\n ========== packLayout: ==========')
    // console.log('selectedImpactTypeList: ', selectedImpactTypeList)
    // console.log('updatedEntityFieldData: ', updatedEntityFieldData)

    // check if circle packing can be run
    if (updatedEntityFieldData.length === 0) return // Ensure we have data
    if (selectedImpactTypeList.length === 0) return // Ensure we have selected types

    // circle packing
    /* opt 1: pack circle for all impact entity types, together.
       好处: all node_size are with the same scale
    */
    // 1. create a root node for circle packing
    const impactTypeEntityAll: BubbleNodeDatum = {
      name: 'impact-type-entity-root',
      type: 'root',
      x: bubbleTreemapStyle.x,
      y: bubbleTreemapStyle.y,
      radius: bubbleTreemapStyle.radius,
      children: [] as BubbleNodeDatum[],
    }

    // Only add entities that are in selectedImpactTypeList
    updatedEntityFieldData.forEach(entityData => {
      const entityName = entityData.name
      const entityType = entityData.type
      const children = entityData.children

      if ((entityName === 'grant') || (!selectedImpactTypeList.includes(entityName))) {
        // Skip entities not in selectedImpactTypeList
        return
      } else {
        impactTypeEntityAll.children!.push({
          name: entityName,
          type: entityType,
          x: 0,
          y: 0,
          radius: 0,
          children: children,
        })
      }
    })

    // console.log('Final impactTypeEntityAll: ', impactTypeEntityAll)
    // console.log('impactTypeEntityAll.children: ', impactTypeEntityAll.children)

    let root = d3.hierarchy<BubbleNodeDatum>(impactTypeEntityAll)
                    .sum((d: BubbleNodeDatum) => d.value ?? 0)

    // 2. set leaf node size scale
    // const leafNodeSizeScaleType = bubbleTreemapStyle.leafNodeSizeScaleType
    if (leafNodeSizeScaleType === 'linear') {
      // pass
    } else if (bubbleTreemapStyle.leafNodeSizeScaleType === 'pow') {
      root = d3.hierarchy<BubbleNodeDatum>(impactTypeEntityAll)
              .sum((d: BubbleNodeDatum) => Math.pow(d.value ?? 0, bubbleTreemapStyle.powParam))
    } else if (bubbleTreemapStyle.leafNodeSizeScaleType === 'log') {
      root = d3.hierarchy<BubbleNodeDatum>(impactTypeEntityAll)
              .sum((d: BubbleNodeDatum) => Math.log10((d.value ?? 0) + 1))
    } else {
      console.log('error: leafNodeSizeScaleType!')
    }

    // 3. start circle packing
    const packLayout = d3.pack<BubbleNodeDatum>()
      .size([impactTypeEntityAll.radius, impactTypeEntityAll.radius])
      // .size([impactTypeEntityAll.radius * 2, impactTypeEntityAll.radius * 2]) // Use entity radius to determine the packing size
      .padding(bubbleTreemapStyle.padding.leafNodePadding)
    const packedData = packLayout(root)  // Perform circle packing within each entity node
    const dataTempOneRoot = packedData.descendants()

    // update state: as the input for drawBubbleTreemap()
    setPackedImpactEntityAll(dataTempOneRoot)
  },
  [
    selectedImpactTypeList,
    updatedEntityFieldData,
  ])


  // 2-3 functions for interactions
  const [highlightedNode, setHighlightedNode] = useState<HighlightedGrantGroupNode>({
    grantFieldID: '',
    grantFieldName: '',
  })

  // opt 1: useCallback to make action references stable
  // 事件回调（保持引用稳定）
  const handleMouseRightClick = useCallback((e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const impactEntity: string = parts[2];
    console.log('impactEntity: ', impactEntity);
  }, []);

  const handleMouseLeave = useCallback((e: MouseEvent, id: string) => {
    isShowWordle(false);
  }, [isShowWordle]);

  const handleMouseEnter = useCallback((e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];
    isShowWordle(true);
    updateWordlePosition({ left: e.clientX + 24, top: e.clientY + 24 });
    updateWordleEntity({ entity: impactEntity, fieldID });
  }, [isShowWordle, updateWordlePosition, updateWordleEntity]);

  const handleMouseOnClick = useCallback((e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];

    if (citationFlowType === CitationFlowType.HISTORICAL) {
      updateSelectedImpactEntityField({ [impactEntity]: fieldID });
      isShowPredictionFlow(false);
      isShowHistoricalFlow(true);
    } else if (citationFlowType === CitationFlowType.PREDICTION) {
      const predictionSearchResult: MainViewTypes.PredictionSearchResult = {
        entity: impactEntity,
        fieldIDList: [fieldID],
      };
      updatePredictionSearchResult(predictionSearchResult);
      isShowPredictionFlow(true);
      isShowHistoricalFlow(false);

      const predictedData = predictionData[impactTypeRefined][impactEntity]
        .find((d: MainViewTypes.PredictionEntityFieldIDUnit) => d.field_id === fieldID);
      const predictedDataGlobal = predictionDataGlobal[impactTypeRefined][impactEntity]
        .find((d: MainViewTypes.PredictionEntityFieldIDUnit) => d.field_id === fieldID);
      if (predictedData) {
        updatePredictionGrantIDList4PIView(predictedData.grant_id_list, predictedDataGlobal.grant_id_list);
      }
      onClickGrantFieldNode({ grantFieldID: '', grantFieldName: '', impactType });
      onClickImpactFieldNode({ impactType: '', impactEntity: '', impactFieldID: '' });
      setHighlightedNode({ grantFieldID: fieldID, grantFieldName: impactEntity });
    }
  }, [
    citationFlowType, impactType, impactTypeRefined,
    predictionData, predictionDataGlobal,
    updateSelectedImpactEntityField, isShowPredictionFlow, isShowHistoricalFlow,
    updatePredictionSearchResult, updatePredictionGrantIDList4PIView,
    onClickGrantFieldNode, onClickImpactFieldNode
  ]);


  // // opt 2: original functions
  // const handleMouseRightClick = (e: MouseEvent, id: string) => {
  //   const parts = id.split("-");
  //   const impactEntity: string = parts[2];
  //   console.log('impactEntity: ', impactEntity)

  //   // // show context menu
  //   // isShowContextMenu(true)
  //   // updateContextMenuImpactEntity(impactEntity)
  //   // updateContextMenuPosition({
  //   //   left: e.clientX + 8,
  //   //   top: e.clientY + 8,
  //   // })
  // }
  // const handleMouseLeave = (e: MouseEvent, id: string) => {
  //   const parts = id.split("-");
  //   const fieldID: string = parts[2];
  //   const impactEntity: string = parts[3];

  //   // hide wordle
  //   isShowWordle(false)
  // }
  // const handleMouseEnter = (e: MouseEvent, id: string) => {
  //   const parts = id.split("-");
  //   const fieldID: string = parts[2];
  //   const impactEntity: string = parts[3];

  //   // console.log('\n\n\nhandleMouseEnter: ', fieldID, impactEntity)

  //   // show wordle
  //   isShowWordle(true)
  //   updateWordlePosition({
  //     left: e.clientX + 24,
  //     top: e.clientY + 24,
  //   })
  //   updateWordleEntity({
  //     // impact type (direct/indirect): 用state变量impactType即可
  //     entity: impactEntity,
  //     fieldID: fieldID,
  //   })
  // }
  // const handleMouseOnClick = (e: MouseEvent, id: string) => {
  //   const parts = id.split("-");
  //   const fieldID: string = parts[2];
  //   const impactEntity: string = parts[3];

  //   // 根据impact type，决定
  //   // 1. historical的时候，只更新右下角
  //   // 2. prediction的时候，只更新PI view信息

  //   // console.log('\n\n\n========== handleMouseOnClick: ==========')
  //   // console.log('citationFlowType: ', citationFlowType)
  //   // console.log('impactTypeRefined: ', impactTypeRefined)
  //   // console.log('impactEntity: ', impactEntity) // impact type: paper, patent, clinical_trial, policy, newsfeed
  //   // console.log('fieldID: ', fieldID) // impact field ID
  //   // console.log('========== handleMouseOnClick: ==========\n\n\n')


  //   if (citationFlowType === CitationFlowType.HISTORICAL) {
  //     // (1) if historical flow, 接xiaoyu右下角barchart更新
  //     updateSelectedImpactEntityField({
  //       [impactEntity]: fieldID,
  //     })
  //     isShowPredictionFlow(false)
  //     isShowHistoricalFlow(true)
  //     // 以及点击一个impact field node以后，右下角更新chart的接口是state的哪里？
  //   } else if (citationFlowType === CitationFlowType.PREDICTION) {
  //     // (2) if prediction flow, 高亮prediction result: grantNode + flow高亮 + PI view更新
  //     const predictionSearchResult: MainViewTypes.PredictionSearchResult = {
  //       entity: impactEntity, // 'clinical_trial',
  //       fieldIDList: [fieldID], // ['C11.768', 'C23.888'],
  //     }
  //     updatePredictionSearchResult(predictionSearchResult)
  //     isShowPredictionFlow(true) // 从impact entity field出发画flow
  //     isShowHistoricalFlow(false) // 从grant_field出发画flow。本质flow是一样的，只是highlight的flow不一样

  //     // update PI view
  //     const predictedData = predictionData[impactTypeRefined][impactEntity].find((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => fieldIDData.field_id === fieldID)
  //     const predictedDataGlobal = predictionDataGlobal[impactTypeRefined][impactEntity].find((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => fieldIDData.field_id === fieldID)
  //     if (predictedData) {
  //       updatePredictionGrantIDList4PIView(predictedData.grant_id_list, predictedDataGlobal.grant_id_list)
  //     }
  //     // 以及点击一个impact field node以后，右下角更新chart的接口是state的哪里？

  //     // clear up historical selected (1) citation flow (2) highlight node
  //     onClickGrantFieldNode({
  //       grantFieldID: '',
  //       grantFieldName: '',
  //       impactType: impactType,
  //       // impactType: ImpactType.DIRECT_IMPACT,
  //     })
  //     // clear highlighted impact field node
  //     onClickImpactFieldNode({
  //       impactType: '',
  //       impactEntity: '',
  //       impactFieldID: '',
  //     })

  //     // change node color in this component
  //     // debug
  //     console.log('==> InitializeBubbleTreemap() > highlightedNode: ', {
  //       grantFieldID: fieldID,
  //       grantFieldName: impactEntity,
  //     })
  //     setHighlightedNode({
  //       grantFieldID: fieldID,
  //       grantFieldName: impactEntity,
  //     })
  //   }
  // }


  // 2-4 for each entity type, recursively render nodes from different hierarchy
  /* Parameters:
      input: `packedEntityTypes`
      output: `bubbleTreemapEntityTypeGroupElementList` (JSX.Element[])
      method: refine based on bubble treemap calc (d3-bubbletreemap.js):
        - (1) keep all leaf nodes remain the same;
        - (2) remove all higher-level node circles, replace with contour
  */
  const padding: number = bubbleTreemapStyle.padding.outerPadding
  const curvature: number = 10

  // // init output variables
  // let leafNodeSizeScale: number = 0
  // let bubbleTreemapEntityTypeGroupElementList: JSX.Element[] = []
  // let bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[] = [] // for edge bundling, calc the correct node (cx, cy)
  // let leafNodePositionList: MainViewTypes.LeafNodePosition[] = []
  // let bubbleTreemapEntityGroupList: MainViewTypes.BubbleTreemapEntityTypeGroup[] = []
  // let bubbleTreemapGeometryGroup: MainViewTypes.BubbleTreemapGeometryGroup[] = []


  // ============= helper functions =============

  // opt 1: useMemo to make action references stable
  // 变换函数
  const getTransformedValue = useCallback((value: number, scaleType: string) => {
    switch (scaleType) {
      case 'pow':    return Math.pow(value, bubbleTreemapStyle.powParam);
      case 'linear': return value;
      case 'log':    return Math.log(value + 1);
      default:       return value;
    }
  }, [bubbleTreemapStyle.powParam]);

  // 提取缩放因子
  const extractScaleFactor = useCallback((referenceNodeValue: number, referenceNodeR: number, scaleType: string) => {
    const transformedValue = getTransformedValue(referenceNodeValue, scaleType);
    const theoreticalRadius = Math.sqrt(transformedValue / Math.PI);
    return referenceNodeR / theoreticalRadius;
  }, [getTransformedValue]);

  // // opt 2: original functions
  // // 1. 提取缩放因子
  // const extractScaleFactor = (referenceNodeValue: number, referenceNodeR: number, scaleType: string) => {
  //   const transformedValue = getTransformedValue(referenceNodeValue, scaleType);
  //   const theoreticalRadius = Math.sqrt(transformedValue / Math.PI);
  //   const actualRadius = referenceNodeR;
  //   const scaleFactor = actualRadius / theoreticalRadius;

  //   return scaleFactor;
  // };
  // // 3. 变换函数（唯一的区别）
  // const getTransformedValue = (value: number, scaleType: string) => {
  //   switch (scaleType) {
  //       case 'pow': return Math.pow(value, bubbleTreemapStyle.powParam);
  //       case 'linear': return value;
  //       case 'log': return Math.log(value + 1);
  //       default: return value;
  //   }
  // };


  // opt 1: useCallback to make action references stable
  // 依赖于数据与稳定回调的 memo 计算

  // debug: 打印依赖变化
  useWhyChanged("treemapComputed deps", {
    packedImpactEntityAll,
    updatedEntityFieldData,     // 注意：如果每次都是新数组，日志会一直说它变了
    selectedImpactTypeList,     // 同理，如果父层每次都 new 数组
    leafNodeSizeScaleType,
    isShowLeafNode,
    highlightedNode,            // 如果 setState 时新建了对象，即使内容相同也会“变”
    padding,
    curvature,
    extractScaleFactor,
    getTransformedValue,
    handleMouseRightClick,
    handleMouseLeave,
    handleMouseEnter,
    handleMouseOnClick,
  });

  const treemapComputed = useMemo(() => {
    // Ensure we have valid packed data before proceeding
    if (!packedImpactEntityAll || packedImpactEntityAll.length === 0) {
      console.log('treemapComputed: No packedImpactEntityAll data, returning null')
      return null;
    }

    // // Log the data for debugging
    // console.log('treemapComputed: Computing with selectedImpactTypeList:', selectedImpactTypeList)
    // console.log('treemapComputed: packedImpactEntityAll length:', packedImpactEntityAll.length)

    return drawBubbleTreemap(
      packedImpactEntityAll,
      updatedEntityFieldData,
      selectedImpactTypeList,
      leafNodeSizeScaleType,
      isShowLeafNode,
      groupRefs,
      highlightedNode,
      handleMouseRightClick,
      handleMouseLeave,
      handleMouseEnter,
      handleMouseOnClick,
      padding,
      curvature,
      extractScaleFactor,
      getTransformedValue,
    ) as {
      bubbleTreemapEntityGroupList: MainViewTypes.BubbleTreemapEntityTypeGroup[],
      bubbleTreemapGeometryGroup: MainViewTypes.BubbleTreemapGeometryGroup[],
      leafNodePositions: MainViewTypes.LeafNodePosition[],
      leafNodeSizeScale: number,
    };
  }, [
    // Core data dependencies
    packedImpactEntityAll,
    selectedImpactTypeList,
    updatedEntityFieldData,

    // UI state dependencies
    leafNodeSizeScaleType,
    // isShowLeafNode,
    // highlightedNode,

    // Layout dependencies
    isEntityTypeGraphFinished,
    padding,
    curvature,

    // Function dependencies
    extractScaleFactor, // 已是 useCallback
    getTransformedValue, // 已是 useCallback
    handleMouseRightClick,
    handleMouseLeave,
    handleMouseEnter,
    handleMouseOnClick,
  ]);

  // 使用 memo 结果（保持你原有变量名，下面的逻辑不用变）
  const {
    bubbleTreemapEntityGroupList = [],
    bubbleTreemapGeometryGroup = [],
    leafNodePositions: leafNodePositionList = [],
    leafNodeSizeScale = 0,
  } = treemapComputed ?? {};

  const bubbleTreemapEntityTypeGroupElementList =
    bubbleTreemapEntityGroupList.map(et => et.JSXElement);

  const bubbleTreemapEntityTypeCenterXYList =
    bubbleTreemapEntityGroupList.map(et => ({ center: et.center, entityType: et.entityType }));




  // // opt 2: original functions --- start ---
  // // init output variables
  // let leafNodeSizeScale: number = 0
  // let bubbleTreemapEntityTypeGroupElementList: JSX.Element[] = []
  // let bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[] = [] // for edge bundling, calc the correct node (cx, cy)
  // let leafNodePositionList: MainViewTypes.LeafNodePosition[] = []
  // let bubbleTreemapEntityGroupList: MainViewTypes.BubbleTreemapEntityTypeGroup[] = []
  // let bubbleTreemapGeometryGroup: MainViewTypes.BubbleTreemapGeometryGroup[] = []
  // if (packedImpactEntityAll) {
  //   const {
  //     bubbleTreemapEntityGroupList: bubbleTreemapEntityGroupListFromFunction,
  //     bubbleTreemapGeometryGroup: bubbleTreemapGeometryGroupFromFunction,
  //     leafNodePositions,
  //     leafNodeSizeScale: leafNodeSizeScaleFromFunction
  //   } = drawBubbleTreemap(
  //                                 packedImpactEntityAll,
  //                                 updatedEntityFieldData,
  //                                 selectedImpactTypeList,
  //                                 leafNodeSizeScaleType,
  //                                 isShowLeafNode,
  //                                 groupRefs,
  //                                 highlightedNode,
  //                                 handleMouseRightClick,
  //                                 handleMouseLeave,
  //                                 handleMouseEnter,
  //                                 handleMouseOnClick,
  //                                 padding,
  //                                 curvature,
  //                                 extractScaleFactor,
  //                                 getTransformedValue,
  //                               ) as {
  //                                 bubbleTreemapEntityGroupList: MainViewTypes.BubbleTreemapEntityTypeGroup[],
  //                                 bubbleTreemapGeometryGroup: MainViewTypes.BubbleTreemapGeometryGroup[],
  //                                 leafNodePositions: MainViewTypes.LeafNodePosition[],
  //                                 leafNodeSizeScale: number,
  //                                 // leafNodeSizeScaleType: string, // 'pow', 'log', 'linear',
  //                               }
  //   leafNodeSizeScale = leafNodeSizeScaleFromFunction
  //   bubbleTreemapEntityGroupList = bubbleTreemapEntityGroupListFromFunction
  //   bubbleTreemapGeometryGroup = bubbleTreemapGeometryGroupFromFunction
  //   leafNodePositionList = leafNodePositions
  //   bubbleTreemapEntityTypeGroupElementList = bubbleTreemapEntityGroupList.map(entityTypeData => entityTypeData.JSXElement)
  //   bubbleTreemapEntityTypeCenterXYList = bubbleTreemapEntityGroupList.map(entityTypeData => ({
  //     center: entityTypeData.center,
  //     entityType: entityTypeData.entityType,
  //   }))
  // }
  // // opt 2: original functions --- end ---


  // debug: create circumscribed circles layer (外接圆of each impact type bubble)
  // opt 1: useMemo to make action references stable
  // memo 外接圆层，只有中心点或半径变化时才会重渲染
  const renderCircumscribedCircles = useMemo(() => {
    return bubbleTreemapEntityTypeCenterXYList
      .map(({ center, entityType }) => {
        const r = circumscribedRadii[entityType];
        if (!r) return null;
        return (
          <circle
            key={`circumscribed-circle-${entityType}`}
            id={`circumscribed-circle-${entityType}`}
            cx={center.x}
            cy={center.y}
            r={r}
            fill="none"
            stroke="#ff000033"
            strokeWidth={2}
            strokeDasharray="5,5"
          />
        );
      })
      .filter(Boolean) as JSX.Element[];
  }, [bubbleTreemapEntityTypeCenterXYList, circumscribedRadii]);

  // // opt 2: original functions
  // const renderCircumscribedCircles = () => {
  //   return bubbleTreemapEntityTypeCenterXYList.map(({ center, entityType }) => {
  //     if (circumscribedRadii[entityType]) {
  //       return (
  //         <circle
  //           key={`circumscribed-circle-${entityType}`}
  //           id={`circumscribed-circle-${entityType}`}
  //           cx={center.x}
  //           cy={center.y}
  //           r={circumscribedRadii[entityType]}
  //           fill="none"
  //           stroke="#ff000033"
  //           strokeWidth={2}
  //           strokeDasharray="5,5"
  //         />
  //       );
  //     }
  //     return null;
  //   }).filter(Boolean);
  // };
  // // // debug
  // // console.log('bubbleTreemapEntityTypeCenterXYList: ', bubbleTreemapEntityTypeCenterXYList)





  // Check if initial positions have been set
  const isEntityFieldGraphFinished = useSelector((state: State) => state.dataReducer?.isEntityFieldGraphFinished) as boolean;

  // console.log('\n\n\n========== InitializeBubbleTreemap: ==========')
  // console.log('leafNodePositionList: ', leafNodePositionList)
  // console.log('bubbleTreemapEntityTypeCenterXYList: ', bubbleTreemapEntityTypeCenterXYList)
  // console.log('isEntityFieldGraphFinished: ', isEntityFieldGraphFinished)

  // 2-5 update redux state (moved to useEffect to prevent infinite loops)
  useEffect(() => {
    // Only update if we have data and haven't already finished the initial setup
    if (leafNodePositionList.length > 0 && bubbleTreemapEntityTypeCenterXYList.length > 0 && !isEntityFieldGraphFinished) {
      // console.log('SVGGroupWrapper: Updating initial leaf node positions and finishing setup')
      // update leaf node scale in redux
      updateLeafNodeSizeScale(leafNodeSizeScale, leafNodeSizeScaleType)
      // store leaf node positions to state - for drawing edges
      updateLeafNodeInitialPositionList({
        leafNodePositionList: leafNodePositionList,
        bubbleTreemapEntityTypeCenterXYList: bubbleTreemapEntityTypeCenterXYList,
      })
      // send a signal of finished_drawing bubble treemap to start drawing citation links
      updateIsInitializeBubbleTreemapFinished(true)
      // updateIsEntityFieldGraphFinished(true)

      // old version (to delete): update bubble treemap entity group list to state
      updateBubbleTreemapEntityGroupList(bubbleTreemapEntityGroupList)

      // new version: update bubble treemap GeometryGroup instead of `bubbleTreemapEntityGroupList` (JSX.Element[])
      updateBubbleTreemapGeometryGroup(bubbleTreemapGeometryGroup)
    }
  }, [leafNodePositionList, bubbleTreemapEntityTypeCenterXYList, leafNodeSizeScale, leafNodeSizeScaleType, isEntityFieldGraphFinished, updateLeafNodeSizeScale, updateLeafNodeInitialPositionList, updateIsInitializeBubbleTreemapFinished])
  // }, [leafNodePositionList, bubbleTreemapEntityTypeCenterXYList, leafNodeSizeScale, leafNodeSizeScaleType, isEntityFieldGraphFinished, updateLeafNodeSizeScale, updateLeafNodeInitialPositionList, updateIsEntityFieldGraphFinished])

  // 2-6 adjust layout with optimization function
  // note: 2-2和2-3应该换一下位置。先把node位置确定好以后，再加contour
  // TODO

  // console.log('showEntityFieldLevelGraph: ', showEntityFieldLevelGraph)
  // console.log('========== [Step 3] Component: EntityFieldLevelGraph (finished!) ============\n\n')

  // console.log('================ InitializeBubbleTreemap: ended! =================')


  return (
    <g id='initialize-bubble-treemap-g' opacity={0}>
      {bubbleTreemapEntityTypeGroupElementList}
      {renderCircumscribedCircles}
    </g>
  )
}

export default InitializeBubbleTreemap;










